import { Stack } from "@mui/material";

import { BookingCardContentWrapper } from "../../Shift/CardContentWrapper";
import { type TimeSlot } from "../../Shift/Open/types";
import { BookingCardSummaryWrapper } from "../../Shift/SummaryWrapper";
import { TimeSlotIndicator } from "../../Shift/TimeSlotIndicator";
import { ShiftDate } from "./ShiftDate";
import { ShiftHistoryCardFooter } from "./ShiftHistoryCardFooter";
import { ShiftTimeDetails } from "./ShiftTimeDetails";
import { WorkplaceInfo } from "./WorkplaceInfo";

export interface ShiftHistoryCardContentProps {
  timeSlot: TimeSlot;
  shiftStartDate: Date;
  shiftEndDate: Date;
  workplaceId: string;
  workplaceName: string;
  workplaceTimezone: string;
  totalPayInDollars: number;
  qualificationText: string;
  isVerified: boolean;
  verifiedBreakDurationInMinutes: number;
  workplaceBreakDurationInMinutes: number;
  isMissedPunchRequestEnabled: boolean;
  hasPendingExtraWorkedTimeRequest: boolean;
  isTimesheetUploaded: boolean;
  isRequestingShiftAdjustment: boolean;
  shouldDisableButton: boolean;
  onUploadTimesheetClick: () => void;
  onChatWithSupportClick: () => void;
  onRequestShiftAdjustmentClick: () => void;
}

export function ShiftHistoryCardContent(props: ShiftHistoryCardContentProps) {
  const {
    timeSlot,
    shiftStartDate,
    shiftEndDate,
    workplaceId,
    workplaceName,
    workplaceTimezone,
    totalPayInDollars,
    qualificationText,
    isVerified,
    verifiedBreakDurationInMinutes,
    workplaceBreakDurationInMinutes,
    isMissedPunchRequestEnabled,
    hasPendingExtraWorkedTimeRequest,
    isTimesheetUploaded,
    isRequestingShiftAdjustment,
    shouldDisableButton,
    onUploadTimesheetClick,
    onChatWithSupportClick,
    onRequestShiftAdjustmentClick,
  } = props;

  return (
    <BookingCardContentWrapper>
      <BookingCardSummaryWrapper>
        <TimeSlotIndicator timeSlot={timeSlot} />
        <Stack spacing={3}>
          <ShiftDate shiftStartDate={shiftStartDate} workplaceTimezone={workplaceTimezone} />
          <ShiftTimeDetails
            shiftStartDate={shiftStartDate}
            shiftEndDate={shiftEndDate}
            workplaceTimezone={workplaceTimezone}
            isVerified={isVerified}
            verifiedBreakDurationInMinutes={verifiedBreakDurationInMinutes}
            workplaceBreakDurationInMinutes={workplaceBreakDurationInMinutes}
          />
          <WorkplaceInfo workplaceId={workplaceId} workplaceName={workplaceName} />
        </Stack>
      </BookingCardSummaryWrapper>
      <ShiftHistoryCardFooter
        totalPayInDollars={totalPayInDollars}
        qualificationText={qualificationText}
        isVerified={isVerified}
        shouldDisableButton={shouldDisableButton}
        isMissedPunchRequestEnabled={isMissedPunchRequestEnabled}
        hasPendingExtraWorkedTimeRequest={hasPendingExtraWorkedTimeRequest}
        isTimesheetUploaded={isTimesheetUploaded}
        isRequestingShiftAdjustment={isRequestingShiftAdjustment}
        onUploadTimesheetClick={onUploadTimesheetClick}
        onChatWithSupportClick={onChatWithSupportClick}
        onRequestShiftAdjustmentClick={onRequestShiftAdjustmentClick}
      />
    </BookingCardContentWrapper>
  );
}
